declare var pglob : IPhotometerGlobalVar;

module partner {
  'use strict';

  export class PartnerCtrl {

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope', 
      '$http', 
      '$window',
      '$element',
      '$timeout',
      '$q',
      'partnerService',
      'pageMetaService',
      'parallaxService',
    ];

    // dependencies are injected via AngularJS $injector
    constructor(
      private $scope : IPartnerScope,
      private $http : ng.IHttpService,
      private $window : ng.IWindowService,
      private $element : ng.IRootElementService,
      private $timeout : ng.ITimeoutService,
      private $q : ng.IQService,
      private partnerService : PartnerService,
      private pageMetaService: navigation.IPageMetaService,
      private parallaxService: navigation.IParallaxService
      ) {
     
      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      $scope.googleMapsUrlWithKey = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAF1xLcjeFHOKAXWqhsv1x6cc7tIVtDlzU" //Api Key Managable from Google Cloud Console with admin@photometer.com

      var postLoad : () => void = function() {
        var currentCountry : Country[] = $scope.vendordata.Countries.filter(function(val:Country, index: number):boolean {
          return val.Code === $scope.vendordata.LocationCountryCode;
        });
        $scope.selectedCountry = currentCountry[0]; // country of the visitor or null if not found
        $scope.vm.onCountryChange();

        $scope.showOverlay = $scope.vm.getAreaData($scope.selectedCountry) != null && (
                                    $scope.vm.getAreaData($scope.selectedCountry).Vendors != null
                                    || $scope.vm.getAreaData($scope.selectedCountry).Areas != null);
      };

      // var boxWidth : number = -1 * 323;

      partnerService.getPartnerData().then(function(data : VendorResult):void {
        $scope.vendordata = data;        
        postLoad();
      });

      partnerService.setPartnerCtrlElement($element);

    }
    
    
    loadCountries() { 
      return this.$timeout(() => {
        if (!(this.$scope.Countries)) this.$scope.Countries = this.$scope.vendordata.Countries;
      }, 200);
    }


    onCountryChange() {
      this.$scope.selectedArea = null;
      this.$scope.selectedVendor = null;

      var c = this.$scope.selectedCountry;
      if (c && this.getAreaData(c)) {
        if (c && this.getAreaData(c).Vendors) this.$scope.selectedVendor = this.selectVendorForCurrentBusinessArea(this.getAreaData(c));
        if (c && this.getAreaData(c).Areas) this.$scope.selectedArea = this.getAreaData(c).Areas[0];
      }
      if (this.$scope.selectedArea && this.$scope.selectedArea.Vendors) this.$scope.selectedVendor = this.$scope.selectedArea.Vendors[0];

      if (this.$scope.selectedCountry && this.$scope.selectedCountry.VendorId != null) {
        this.$scope.showOverlay = false; 
      }

      this.$scope.showOverlay = this.$scope.vm.getAreaData(this.$scope.selectedCountry) != null && (
                                      this.$scope.vm.getAreaData(this.$scope.selectedCountry).Vendors != null
                                      || this.$scope.vm.getAreaData(this.$scope.selectedCountry).Areas != null);
    }

    onAreaChange() {
      this.$scope.selectedVendor = this.selectVendorForCurrentBusinessArea(this.$scope.selectedArea);
    }

    selectVendorForCurrentBusinessArea(a : AreaData | Area) : VendorWBusinessArea {
      var def = a.Vendors[0];
      if (a.Vendors.length < 2) return def; //der einzige

      var rpm : IRouteParameter  = this.pageMetaService.searchRouteParameter("BusinessArea");
      if (!rpm) return def;

      var currentBusinessAreaId = rpm.Id;

      //a.Vendors[1].BusinessAreasList[0].ID
      var vArr = a.Vendors.filter((v, i) : boolean => {
        return v.BusinessAreasList.filter((ba, j) : boolean => {
          return ba.ID == currentBusinessAreaId;
        }).length > 0;
      });
      if (vArr.length > 0) return vArr[0]; 
      return def;
    }

    getAreaData(c : Country) : AreaData {
      if (!c) return null;
      return this.$scope.vendordata.AreaData[c.ID];
    }

    getSelectedVendor() {
      if (this.$scope.selectedCountry && this.$scope.selectedCountry.VendorId) {
        return this.$scope.vendordata.Vendors[this.$scope.selectedCountry.VendorId];
      }

      if (this.$scope.selectedVendor && this.$scope.selectedVendor.VendorId) {
        return this.$scope.vendordata.Vendors[this.$scope.selectedVendor.VendorId];
      }

      return null;
    }

    setVendor(ba : BusinessArea) {      
      this.$scope.selectedBusinessArea = ba;  
      var c = this.$scope.selectedCountry;
      var vendor : VendorWBusinessArea = null;
      if (c && this.getAreaData(c)) {
        if (this.getAreaData(c).Vendors) {
          vendor = this.getVendorByBusinessAreaId(this.getAreaData(c).Vendors, ba.ID);          
        }
        if (this.$scope.selectedOverlayArea && this.$scope.selectedOverlayArea.Vendors) {
          vendor = this.getVendorByBusinessAreaId(this.$scope.selectedOverlayArea.Vendors, ba.ID);
        }

      }

      if (vendor) {
        if (this.$scope.selectedOverlayArea) {
          this.$scope.selectedArea = this.$scope.selectedOverlayArea;
        }
        this.$scope.selectedVendor = vendor;
        this.$scope.showOverlay = false;
      }
    }

    setOverlayArea(area : Area) {
      this.$scope.selectedOverlayArea = area;
      
      //only one vendor in this area.
      if (area.Vendors.length == 1) {
        this.$scope.selectedArea = area;
        this.$scope.selectedVendor = area.Vendors[0];
        this.$scope.showOverlay = false;
      }
    }

    isVendorSelected(vendor : VendorWBusinessArea) : boolean {
      return vendor.VendorId == this.$scope.selectedVendor.VendorId;
    }

    getVendorByBusinessAreaId(vendors : VendorWBusinessArea[], baId : number ) {
      var v : VendorWBusinessArea[] = vendors.filter((v, index, arr) => {
            return v.BusinessAreasList.filter((b, index, array) => {
              return baId == b.ID
            }).length > 0;
      });
      if (v.length > 0) return v[0]; 
      //übrige Geschäftsfelder lösen wir rekursiv auf.
      if (baId != 0) return this.getVendorByBusinessAreaId(vendors, 0);
      return null;
    }

    

    getBusinessAreasByCountryOrArea(vendors : VendorWBusinessArea[]) {
      if (!vendors) return null;
      var baList = [];
      
      this.$scope.vendordata.BusinessAreas.forEach((ba, i, arr) => {
        var v = this.getVendorByBusinessAreaId(vendors, ba.ID);
        if (v != null) baList.push(ba);
      });
      return baList;
    }


    getBusinessAreaStringByVendor(vendor: VendorWBusinessArea) {
      if (!vendor) return null;
      var baList = "";
      
      this.$scope.vendordata.BusinessAreas.forEach((ba, i, arr) => {
        var v = this.getVendorByBusinessAreaId([vendor], ba.ID);
        if (v != null) baList += ba.Name + ", ";
      });
      return baList.replace(/, $/, "");
    }

  }
}